const FOCUSABLE_ELEMENTS = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'];
const TAB_KEY = 9;
const ESCAPE_KEY = 27;

export function getCurrentLanguage(): string {
    return (window as any).currentCulture.length > 0 ? (window as any).currentCulture : null;
}

export function getFocusableChildren(node): Array<any> {
    let focusableChildrenList = node.querySelectorAll(FOCUSABLE_ELEMENTS.join(','));
    let filteredFocusableChildren = [].slice.call(focusableChildrenList).filter(child => {
        return !!(child.offsetWidth || child.offsetHeight || child.getClientRects().length);
    });

    return filteredFocusableChildren;
}

export function bindKeypress(e, focusableElements, closeFunction) {

    // if modal is shown and esc is pressed
    if (e.which === ESCAPE_KEY) {
        e.preventDefault();
        if (closeFunction != null) {
            closeFunction();
        }
    }

    // if modal is shown and tab is pressed
    if (e.which === TAB_KEY) {
        // trap focus within dialog
        window.setTimeout(function () {
            let focusedItemIndex = focusableElements.indexOf(document.activeElement);

            if (focusedItemIndex < 0) {
                focusableElements[0].focus();
            } else if (e.shiftKey && focusedItemIndex === 0) {
                // if SHIFT+TAB pressed, move focus to last focusable item
                focusableElements[focusableElements.length - 1].focus();
                e.preventDefault();
            }
            //else {
            //    focusableElements[focusedItemIndex + 1 == focusableElements.length ? 0 : focusedItemIndex + 1].focus();
            //    e.preventDefault();
            //}
            // if SHIFT isn't pressed, and current focused item is last in array, move to first index
            //else if (!e.shiftKey && focusedItemIndex === focusableElements.length - 1) {
            //    focusableElements[0].focus();
            //    e.preventDefault();
            //}
        }, 0);

    }
}
